import React from 'react';
import { Box, Typography, FormControl, InputLabel, MenuItem, Select, FormHelperText } from '@mui/material';
import { useConfig } from '../../../../context/ConfigContext';

const YearSelector = () => {
  const { taxYear, setTaxYear } = useConfig();

  const handleYearChange = (event) => {
    setTaxYear(event.target.value);
  };

  // Define helper texts for each tax year option.
  const helperTexts = {
    '2000': 'Tax Year 00/01 runs from 6th April 2000 to 5th April 2001.',
    '2024': 'Tax Year 24/25 runs from 6th April 2024 to 5th April 2025.',
    '2025': 'Tax Year 25/26 runs from 6th April 2025 to 5th April 2026.',
  };

  return (
    <Box sx={{ mb: 2 }}>
      <Typography variant="h6" gutterBottom>
        Select Tax Year
      </Typography>
      <FormControl fullWidth sx={{ mb: 2 }}>
        <InputLabel id="year-label">Tax Year</InputLabel>
        <Select
          labelId="year-label"
          value={taxYear}
          label="Tax Year"
          onChange={handleYearChange}
        >
          <MenuItem value="2025">25/26 (Current)</MenuItem>
          <MenuItem value="2024">24/25</MenuItem>
        </Select>
        <FormHelperText>
          {helperTexts[taxYear] || 'Select a tax year.'}
        </FormHelperText>
      </FormControl>
    </Box>
  );
};

export default YearSelector;
